import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { AngularFireStorage } from "@angular/fire/compat/storage";
import { generateRandomString } from "src/services/utils/string.utils";
import { firstValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UploadService {
  constructor(private readonly angularFireStorage: AngularFireStorage) {}

  public async uploadImageAndGetPublicUrl(base64File: string, fileExtension: string): Promise<string> {
    const randomId = generateRandomString();
    const filePath = `new_uploads_${environment.production ? "prod" : "dev"}/${randomId}.${fileExtension}`;

    const ref = this.angularFireStorage.ref(filePath);
    await ref.putString(base64File, "base64");

    return await firstValueFrom(ref.getDownloadURL());
  }
}
